import  Tooltip  from "@mui/material/Tooltip";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Navigator = (props) => {
  const location = useLocation();

  const { name, path, path2 , navIcon, onClick, navIconImg, navSVG,liClass } = props;

  const normalizePath = (value) => {
    if (!value) return "";
    return value.endsWith("/") ? value.slice(0, -1) : value;
  };

  const isPathActive = (targetPath) => {
    const currentPath = normalizePath(location.pathname);
    const routePath = normalizePath(targetPath);

    if (!routePath) return false;
    return currentPath === routePath || currentPath.startsWith(`${routePath}/`);
  };

  const mainMenuActive = isPathActive(path) || isPathActive(path2);

  return (
    <ul className="mainMenu">
      <li onClick={onClick} className={liClass}>
        <Tooltip title={name} placement="right">
          <Link
            to={{ pathname: path }}
            className={mainMenuActive ? "activeMenu" : ""}
          >
            <div>
              {navIconImg ? (
                <>
                  <img src={navIconImg} />
                </>
              ) : navIcon ? (
                <>
                  <i className={navIcon}></i>
                </>
              ) : (
                <>{navSVG}</>
              )}
              <span className="text-capitalize">{name}</span>
            </div>
            {props?.children && <i className="fa-solid fa-angle-right"></i>}
          </Link>
        </Tooltip>
        {/* If Submenu */}
        <ul className={`subMenu transform0`}>
          {props.children?.map((res) => {
            const { subName, subPath, subPath2, onClick } = res?.props;
            const subMenuActive = isPathActive(subPath) || isPathActive(subPath2);
            return (
              <>
                <Tooltip title={subName} placement="right">
                  <li>
                    <Link
                      to={{ pathname: subPath }}
                      className={subMenuActive ? "activeMenu" : ""}
                      onClick={onClick}
                    >
                      <i className="fa-solid fa-circle"></i>
                      <span style={{ fontSize: "14px" }}>{subName}</span>
                    </Link>
                  </li>
                </Tooltip>
              </>
            );
          })}
        </ul>
      </li>
    </ul>
  );
};


export default Navigator;
